import { useUser } from '@clerk/clerk-react';
import { Navigate, useLocation } from '@tanstack/react-router';

// Like PrivateRoute but does not wrap children with DashboardWrapper (no chrome).
const PrivateNoChrome = ({ children }) => {
    const { isSignedIn, isLoaded } = useUser();
    const location = useLocation();

    if (isLoaded && !isSignedIn) {
        const currentPath = location.pathname;
        if (currentPath.startsWith('/sign-in') || currentPath.startsWith('/sign-up')) {
            return <Navigate to="/sign-in" replace />;
        }
        return <Navigate to="/sign-in" search={{ redirect: currentPath }} replace />;
    }

    return <>{children}</>;
};

export default PrivateNoChrome;
